import React from 'react'
import { Box, Typography } from '@mui/material'

export default function userColumn() {
    return {
        name: 'userName', label: 'User',
        options: {
            sort: true,
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: 'center' } }),
            customBodyRowRenderLite: (value, row) => (
                <Box>
                    <Typography variant="body2">{value}</Typography>
                    <Typography variant="caption" color="text.secondary">{row.email}</Typography>
                </Box>
            ),
        }
    }
}
